import { getAuthenticatedUserServer } from "@auth/user/sessionUtils";
import { spaceApiIA } from "../clienteSpace";
import type {
	AssistenteIAConfigurarKeyRequest,
	AssistenteIAConfigurarKeyResposta,
	AssistenteIANovaConversaRequest,
	AssistenteIANovaConversaResposta,
	AssistenteIARequest,
	AssistenteIAResposta,
} from "../dtos/assistenteIA.dto";

// ------------------------------- FUNCTIONS -------------------------------
export function responderAssistenteIA(
	request: AssistenteIARequest,
	signal?: AbortSignal,
): Promise<AssistenteIAResposta> {
	return spaceApiIA.post("api/assistente-ia/responder", { json: request, signal }).json<AssistenteIAResposta>();
}

export function iniciarNovaConversaAssistenteIA(tela: string): Promise<AssistenteIANovaConversaResposta> {
	return spaceApiIA
		.post("api/assistente-ia/nova-conversa", {
			json: { tela } satisfies AssistenteIANovaConversaRequest,
		})
		.json<AssistenteIANovaConversaResposta>();
}

export function configurarIAKey(req: AssistenteIAConfigurarKeyRequest): Promise<AssistenteIAConfigurarKeyResposta> {
	const userData = getAuthenticatedUserServer();

	return spaceApiIA
		.post("api/assistente-ia/configuracao", {
			json: {
				...req,
				id_cad_grupo_usuario: userData?.id_cad_grupo_usuario,
			},
		})
		.json<AssistenteIAConfigurarKeyResposta>();
}
